<template>
    <div id="NewFeedback">
        <el-breadcrumb separator="/" class="breadcrumb">
          <el-breadcrumb-item>个人中心</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/PersonalCenter/systemFeedback' }">系统反馈</el-breadcrumb-item>
          <el-breadcrumb-item>新增</el-breadcrumb-item>
        </el-breadcrumb>
        <section class="content-warpper content-warpper-main">
            <el-form label-width="90px">
              <!--  -->
              <el-form-item label="接收方">
                <el-radio v-model="accepttype" label="1">
                  系统管理员
                  <span style="color: #ccc;">（功能异常、产品建议）</span>
                </el-radio>
                <el-radio v-model="accepttype" label="2" v-if="type.logintype != 'HCM' && type.logintype != 'HCMSUB'">
                  品牌方
                  <span style="color: #ccc;">（管理建议）</span>
                </el-radio>
              </el-form-item>
              <div style="display: flex;">
                <div class="titleLable">
                  <span style="color: #F56C6C;">
                    *
                  </span>
                  反馈标题
                </div>
                <el-input placeholder="请选择" v-model="workTitle" size="small"></el-input>
              </div>
              <div style="display: flex;margin-left: -7px;margin-bottom: 24px;">
                <div class="titleLable">
                  <span style="color: #F56C6C;">
                    *
                  </span>
                  反馈详情
                </div>
                <el-input type="textarea" placeholder="请输入备注说明，请保持在200字以内。" resize="none" v-model="details"  size="small"></el-input>
              </div>
              <el-form-item label="上传截图">
                <div class="screenshot">
                  <el-upload
                    class="avatar-uploader"
                    action="https://192.168.1.229:81/hcm/hcmWorkOrder/headImgUpload/"
                    :show-file-list="false"
                    :on-success="handleAvatarSuccess"
                     name="file"
                    :http-request="picRequest"
                     multiple
                    :before-upload="beforeAvatarUpload"
                  >
                    <img v-if="imageUrl" :src="imageUrl" class="avatar">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    <div>上传</div>
                  </el-upload>
                  <div v-for="(item,index) in uploadPicHtpp" :key="index">
                    <img :src="item" alt="" class="screenshot_pic">
                    <i class="el-icon-error" @click="deletePic(index)"></i>
                  </div>
                </div>
                <div class="intro">支持上传9张截图，图片格式PNG、JPG，单张图片大小20M以内。</div>
                <el-button type="primary" @click="saveReport" size="small">确 认</el-button>
                <el-button @click="cancel" size="small" type="TheCustom">取 消</el-button>
              </el-form-item>
            </el-form>
        </section>
    </div>
</template>

<script>
  import axios from "axios";
  import { mapGetters } from 'vuex';
  import {mapActions} from "vuex";
  export default {
      name: "NewFeedback",
      data:function(){
        return{
          accepttype: '1',
          imageUrl: '',
          workTitle: '',
          details: '',
          uploadPicHtpp:[],
          beformuploadPicHtpp:[],
          type: '',
        }
      },
      mounted() {
        this.type = JSON.parse(window.localStorage.userData)
        console.log(this.type.logintype)
      },
      methods:{
        handleAvatarSuccess(res, file) {
          this.imageUrl = URL.createObjectURL(file.raw);
        },
        beforeAvatarUpload(file) {
          const isLt2M = file.size / 1024 / 1024 < 20;
          if (!isLt2M) {
              this.$message.error('上传图片大小不能超过20M!');
              return false;
          }
        },
        picRequest(a){
          //图片上传
          if(this.beformuploadPicHtpp.length>9){
              this.$message({type: 'warning', message: '最多只能上传9张截图'})
              return false
          }
          this.beformuploadPicHtpp.push(1)//本地用来判断上传的图片数量
          let that = this;
          var formdata=new FormData()
          formdata.append('file',a.file)
          let config={
              headers:{
                  'Content-Type':'multipart/form-data'
              }
          }
          const instance=axios.create({
              withCredentials: true,
              timeout:60*5000
          })
          instance.post("hcm/hcmWorkOrder/headImgUpload", formdata,config).then(function(res) {
              let {data}=res
              that.imgUrl = data.data.data;
              that.uploadPicHtpp.push(that.imgUrl)//http格式的图片地址
          });
        },
        deletePic(index){
            //图片删除
            this.uploadPicHtpp.splice(index,1);
            this.beformuploadPicHtpp.splice(index,1);
        },
        cancel() {
          this.$router.push({
            path: '/PersonalCenter/systemFeedback',
          })
        },
        saveReport(){
          if(this.workTitle==''){
              this.$message.error('请填写反馈标题');
              return
          }
          if(this.details==''){
              this.$message.error('请填写反馈详情');
              return
          }
          //提交
          let data={
            workTitle: this.workTitle,
            details: this.details,
            screenshotUrls: this.uploadPicHtpp.join(','),
            sysType: this.type.logintype,
            accepttype: this.accepttype,
          }
          fetch({
              url: "hcm/hcmWorkOrder/saveWorkOrder",
              method: "post",
              data:data,
              noFormat: true,
              responseType: "text"
          })
          .then((res)=>{
              let result=JSON.parse(res)
              if(result.status=='10000'){
                this.$message({type: 'success', message: '保存成功'})
                this.$router.push({
                  path: '/PersonalCenter/systemFeedback',
                })
              }
              //清空
              this.workTitle=''
              this.details=''
              this.uploadPicHtpp=[]
              this.beformuploadPicHtpp=[]
          })
        }
      }
    }
</script>

<style lang="scss">
    #NewFeedback{
        .titleLable {
          width: 100px;
          margin-bottom: 22px;
          text-align: right;
          vertical-align: middle;
          float: left;
          font-size: 14px;
          color: #606266;
          line-height: 32px;
          padding: 0 12px 0 0;
          -webkit-box-sizing: border-box;
          box-sizing: border-box;
        }
        .trumpet_icon_container{
            font-size: 12px;
            color:#faad14;
            background:#fffbf3;
            width: 507px;
            height:28px ;
            line-height: 28px;
            margin-bottom: 20px;
            img{
                width: 14px;
                height: 12px;
                vertical-align: middle;
            }
        }
        .screenshot {
          width: 119px;
          // height: 119px;
          border-radius: 6px;
          margin-right: 40px;
          position: relative;
          text-align: center;
          margin-bottom: 10px;
        }
        .content-warpper{
            .el-input__inner{
                width: 425px;
            }
        }
        .screenshot{
            display:flex;
            flex-wrap: wrap;
            width: 100%;
            .avatar-uploader{
                background: #f7f8f8;
                border:1px dashed #b5b5b5;
            }
            &>div{
                width: 119px;
                height: 119px;
                border-radius: 6px;
                margin-right: 40px;
                position: relative;
                text-align: center;
                margin-bottom: 30px;
            }
            .add_photo{
                border:1px dashed #b5b5b5;
                text-align: center;
            }
            .el-icon-plus{
              color:#bfbfbf;
              font-size: 40px;
              margin-top: 25px;
            }
            .screenshot_pic{
              width: 100%;
              height: 100%;
            }
            .el-icon-error {
                font-size:24px;
                color:#d81e06;
                position: absolute;
                top:-4px;
                right: -3px;
            }
        }
        .intro{
            font-size: 14px;
            color:#999;
            line-height: 14px;
            margin-top: 10px;
            margin-bottom: 20px;
        }
        .el-textarea__inner,.el-textarea{
            width: 425px;
            height: 167px;
        }
        .el-button--primary {
          color: #FFF;
          background-color: #bda571;
          border-color: #bda571;
        }
        .el-button--primary:hover {
          color: #FFF;
          background-color: #c0ae8a;
          border-color: #c0ae8a;
        }
        .el-button--TheCustom {
          color: #666;
          border-color: #D9D9D9;
          background-color: #fff;
        }
        .el-button--TheCustom:hover  {
          color: #666;
          border-color: #ded2b8;
          background-color: #faf9f5;
        }
    }
</style>
